import { Versions } from "./serialization";
export class CardObjectRegistry {
    constructor() {
        this._items = {};
    }
    findByName(typeName) {
        return this._items.hasOwnProperty(typeName) ? this._items[typeName] : undefined;
    }
    clear() {
        this._items = {};
    }
    copyTo(target) {
        const keys = Object.keys(this._items);
        for (const key of keys) {
            const typeRegistration = this._items[key];
            target.register(typeRegistration.typeName, typeRegistration.objectType, typeRegistration.schemaVersion);
        }
    }
    register(typeName, objectType, schemaVersion = Versions.v1_0) {
        let registrationInfo = this.findByName(typeName);
        if (registrationInfo !== undefined) {
            registrationInfo.objectType = objectType;
        }
        else {
            registrationInfo = {
                typeName: typeName,
                objectType: objectType,
                schemaVersion: schemaVersion
            };
        }
        this._items[typeName] = registrationInfo;
    }
    unregister(typeName) {
        delete this._items[typeName];
    }
    createInstance(typeName, targetVersion) {
        const registrationInfo = this.findByName(typeName);
        return registrationInfo && registrationInfo.schemaVersion.compareTo(targetVersion) <= 0
            ? new registrationInfo.objectType()
            : undefined;
    }
    getItemCount() {
        return Object.keys(this._items).length;
    }
    getItemAt(index) {
        return Object.keys(this._items).map((e) => this._items[e])[index];
    }
}
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class GlobalRegistry {
    static populateWithDefaultElements(registry) {
        registry.clear();
        GlobalRegistry.defaultElements.copyTo(registry);
    }
    static populateWithDefaultActions(registry) {
        registry.clear();
        GlobalRegistry.defaultActions.copyTo(registry);
    }
    static get elements() {
        if (!GlobalRegistry._elements) {
            GlobalRegistry._elements = new CardObjectRegistry();
            GlobalRegistry.populateWithDefaultElements(GlobalRegistry._elements);
        }
        return GlobalRegistry._elements;
    }
    static get actions() {
        if (!GlobalRegistry._actions) {
            GlobalRegistry._actions = new CardObjectRegistry();
            GlobalRegistry.populateWithDefaultActions(GlobalRegistry._actions);
        }
        return GlobalRegistry._actions;
    }
    static reset() {
        GlobalRegistry._elements = undefined;
        GlobalRegistry._actions = undefined;
    }
}
GlobalRegistry.defaultElements = new CardObjectRegistry();
GlobalRegistry.defaultActions = new CardObjectRegistry();
//# sourceMappingURL=registry.js.map